module.exports = __webpack_public_path__ + "img/algernon.949dc8c1.png";